import React from "react"

const Header = () => {
  return (
    <header>
      <h1>Em<span className="headerSecondColor">m</span>i's <span className="headerGlow">Art</span> Gal<span className="headerSecondColor">l</span>ery</h1>
    </header>
  )
}

export default Header
